import * as React from 'react';

import * as styles from './styles.css';
import { clsx } from 'clsx';
import { Button, MaskedInput, UIHeading1, UIHeading4, UIText1, UIText3 } from '@cian/ui-kit';

const CODE_MASK = '0000';

interface ISendVerificationCodeModalContentProps {
  isPhone: boolean;
  showRepeatButton: boolean;
  phone: string;
  code: string;
  error: string;
  isDisable?: boolean;
  countDown: number;
  onCodeChange: (val: string) => void;
  onSendCodeClick: () => void;
  onRepeatButtonClick: () => void;
}

export const SendVerificationCodeModalContent: React.FC<ISendVerificationCodeModalContentProps> = ({
  isPhone,
  code,
  phone,
  error,
  isDisable,
  countDown,
  onCodeChange,
  showRepeatButton,
  onSendCodeClick,
  onRepeatButtonClick,
}) => {
  return (
    <div className={clsx(isPhone ? styles['container-mobile'] : styles['container'])}>
      <span className={styles['heading']}>
        <UIHeading1>Подтвердите номер, чтобы продолжить</UIHeading1>
      </span>
      <div className={styles['content']}>
        <UIText1>Введите код из смс — отправили на номер</UIText1> <UIText1 fontWeight="bold">{phone}</UIText1>
      </div>
      <div>
        <MaskedInput
          size="M"
          mask={CODE_MASK}
          value={code}
          onChange={onCodeChange}
          lazy
          invalid={!!error}
          placeholder="Введите код подтверждения"
        />
      </div>
      {!!error && (
        <div className={styles['error']}>
          <UIText3 color="accent-negative-primary">{error}</UIText3>
        </div>
      )}
      {!!countDown && (
        <div className={styles['countdown']}>
          <UIText3 color="text-secondary-default">Получить код повторно можно через {countDown} сек.</UIText3>
        </div>
      )}
      {showRepeatButton && (
        <div className={styles['repeat-button']}>
          <UIHeading4 color="text-main-default" onClick={onRepeatButtonClick}>
            Получить код повторно
          </UIHeading4>
        </div>
      )}
      <div className={clsx(isPhone ? styles['button-mobile'] : styles['button'])}>
        <Button size="M" onClick={onSendCodeClick} fullWidth={isPhone} disabled={isDisable}>
          Подтвердить
        </Button>
      </div>
    </div>
  );
};
